module.exports = __webpack_public_path__ + "img/yinlian.a950e334.png";